import { SET_QUICK_START_STATE } from '../actions/types'

const initialState = {
  apartment: {},
  renewalRentValue: '',
  tenantModalState: {
    open: false,
    tenant: '',
    modalState: '',
  },
  leaseStartValue: null,
  leaseExpirationValue: null,
  header: '',
  quickStartFlow: '',
  tenants: [],
  modalHeader: '',
  redirectLocation: '',
  quickStartModalVisible: true,
  step: 1,
}

const tempInitialState = {
  apartment: {
    buildingId: 6637,
    streetNumber: '111',
    streetName: 'Broadway',
    id: 193209,
    unitNumber: '3LO',
    apartmentOwners: [],
    leases: [
      {
        id: 9523,
        leaseStartDate: '2017-12-01',
        leaseEndDate: '2018-11-30',
        rent: 2676,
        tenants: [],
      },
      {
        id: 9524,
        leaseStartDate: '2019-12-01',
        leaseEndDate: '2020-11-30',
        rent: 2701,
        tenants: [],
      },
      {
        id: 9522,
        leaseStartDate: '2018-12-01',
        leaseEndDate: '2019-11-30',
        rent: 2895,
        tenants: [
          {
            id: 48661,
            firstName: 'Sam',
            lastName: 'Nowakowski',
            phoneNumberCell: '+14148990298',
            email: 'sam@theresidesk.com',
            tenantPeopleLeases: {
              createdA: '2019-08-09T09:50:28.931Z',
              updatedA: '2019-08-09T09:50:28.931Z',
              leaseId: 9522,
              personId: 48661,
            },
          },
        ],
      },
    ],
  },
  renewalRentValue: '2895',
  tenantModalState: { open: false, tenant: '', modalState: '' },
  leaseStartValue: '2019-12-01T05:00:00.000Z',
  leaseExpirationValue: '2020-11-30T05:00:00.000Z',
  header: '',
  quickStartFlow: 'renewal',
  tenants: [
    {
      id: 48661,
      firstName: 'Sam',
      lastName: 'Nowakowski',
      phoneNumberCell: '+14148990298',
      email: 'sam@theresidesk.com',
      tenantPeopleLeases: {
        createdA: '2019-08-09T09:50:28.931Z',
        updatedA: '2019-08-09T09:50:28.931Z',
        leaseId: 9522,
        personId: 48661,
      },
    },
  ],
  modalHeader:
    '<span className="stepName">Step 4</span> Add All the Tenants on the Lease',
  redirectLocation: '',
  quickStartModalVisible: true,
  step: 4,
}
tempInitialState.quickStartModalVisible = false

const quickStart = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_QUICK_START_STATE:
      return {
        ...state,
        ...payload,
      }
    // case RESET_QUICK_START_STATE:
    //   return {
    //     ...state,
    //     ...initialState,
    //   };
    default:
      return state
  }
}

export default quickStart
